module.exports = __webpack_public_path__ + "img/failed_detection.47d0b308.png";